export default defineNuxtPlugin(() => {
  const nuxtConfig = useRuntimeConfig()

  // Merge common config with runtime config here.
  if (typeof window !== 'undefined' && window.__COMMON_CONFIG__) {
    Object.assign(nuxtConfig.public, window.__COMMON_CONFIG__)
  }

  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    Object.assign(nuxtConfig.public, window.__RUNTIME_CONFIG__)
  }

  if (useRuntimeConfig().public.debugEnabled) {
    console.log('assigned $config to window', window.env)
  }
})
